import axios from 'axios';
import store from '../store';
export default {
    namespaced: true,

    state: {
        scodigoproducto: "",
        scostoproducto: "",
        sdisponibleproducto: "",
        sfoto: "",
        sidcaracteristica: "",
        sidcaracteristicaNavigation: "",
        sidcategoriaproducto: "",
        sidcategoriaproductoNavigation: "",
        sidcolorproducto: "",
        sidcolorproductoNavigation: "",
        sidgeneroproducto: "",
        sidgeneroproductoNavigation: "",
        sidgrupoproducto: "",
        sidgrupoproductoNavigation: "",
        sidlineaproducto: "",
        sidlineaproductoNavigation: "",
        sidnivelproducto: "",
        sidnivelproductoNavigation: "",
        sidproducto: "",
        sidtallaproducto: "",
        sidtallaproductoNavigation: "",
        sidtargetproducto: "",
        sidtargetproductoNavigation: "",
        sidusuario: "",
        sidusuarioNavigation: "",
        sivaproducto: "",
        snombreproducto: "",
        sreferenciaproducto: "",
        sreservaproducto: "",
        sconstoproducto: '',
        productos:'',

        transportistas: '',
        tipodedocumento: '',
         targets: '',
        tallas: '',
        niveles: '',
        lineas: '',
        grupos: '',
        generos: '',
        colores: '',
        categorias: '',
        caracteristicas: '',
        producto:'',
        marcas:'',
        smarca:'',
        svalorventa:'',
        referencias:'',
        sreferencia:''
        


    },
    mutations: {
    
      LoadProductos(state,buscar) {
        //let aux = [];
        state.producto = state.productos;
  
        let aux = state.producto.filter((x) => x["nombreproducto"].toUpperCase().includes(buscar.toUpperCase()),);
        if (buscar == "") {
          state.producto = state.productos;
        } else {
          state.producto = aux;
       
        }
      },




        async  cargardatosproductos(state){
      
            state.productos = []
            var token = store.state.numero;
            await axios
            .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/productos", {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
            })
            .then((response) => {
              state.productos = response.data.data;
            
            
            });
            state.producto = state.productos

         
              state.marcas = []
         
              await axios
                  .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/marcas", {
                      headers: {
                          "Content-Type": "application/json",
                          Authorization: "Bearer " + token,
                      },
                  })
                  .then((response) => {
                      state.marcas = response.data.data;
                    
  
                  });

                  state.referencias = []
                  await axios
                    .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/referencias", {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token,
                      },
                    })
                    .then((response) => {
                      state.referencias = response.data.data;
                    

                    });
           
          
  
          },


          cargardatosglobal(state) {

          
            var token = store.state.numero;
            axios
              .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Transportista", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + token,
                },
              })
              .then((response) => {
                //datos transportistas
                state.transportistas = response.data.data;
          
          
              });
            //tipodedocumento
            axios
              .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/tiposdocumentos", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + token,
                },
              })
              .then((response) => {
                state.tipodedocumento = response.data.data;
          
          
              });
            //targets
            axios
              .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/targets", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + token,
                },
              })
              .then((response) => {
                state.targets = response.data.data;
          
          
              });
            //tallas
            axios
              .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/tallas", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + token,
                },
              })
              .then((response) => {
                state.tallas = response.data.data;
          
          
              });
          
            //niveles
          
            axios
              .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/niveles", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + token,
                },
              })
              .then((response) => {
                state.niveles = response.data.data;
          
          
              });
          
            //lineas
          
            axios
              .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/lineas", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + token,
                },
              })
              .then((response) => {
                state.lineas = response.data.data;
            
          
          
              });
            //grupos
            axios
              .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/grupos", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + token,
                },
              })
              .then((response) => {
                state.grupos = response.data.data;
          
          
              });
            //generos
            axios
              .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/generos", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + token,
                },
              })
              .then((response) => {
          
                state.generos = response.data.data;
          
          
              });
            //colores
            axios
              .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/colores", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + token,
                },
              })
              .then((response) => {
                state.colores = response.data.data;
          
          
              });
            //categorias
            axios
              .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/categorias", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + token,
                },
              })
              .then((response) => {
                state.categorias = response.data.data;
          
          
          
              });
            //caracteristicas
            axios
              .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/Caracteristicas", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + token,
                },
              })
              .then((response) => {
                state.caracteristicas = response.data.data;
          
          
              });
          
          
          
          
          },



        cambio(state, descripcion) {

                state.scodigoproducto = descripcion.codigoproducto,
                state.scostoproducto = descripcion.costoproducto,
                state.sdisponibleproducto = descripcion.disponibleproducto,
                state.smarca = descripcion.idmarca,
                state.sfoto = descripcion.foto,
                state.sidcaracteristica = descripcion.idcaracteristica,
                state.sidcategoriaproducto = descripcion.idcategoriaproducto,
                state.sidcolorproducto = descripcion.idcolorproducto,
                state.sidgeneroproducto = descripcion.idgeneroproducto,
                state.sidgrupoproducto = descripcion.idgrupoproducto,
                state.sidlineaproducto = descripcion.idlineaproducto,
                state.sidnivelproducto = descripcion.idnivelproducto,
                state.svalorventa = descripcion.valorventa
                state.sidtallaproducto = descripcion.idtallaproducto,
                state.sidtargetproducto = descripcion.idtargetproducto,
                state.sivaproducto = descripcion.ivaproducto,
                state.snombreproducto = descripcion.nombreproducto,
                state.sreferencia = descripcion.idreferencia,
                state.sreservaproducto = descripcion.reservaproducto,
                state.sconstoproducto = descripcion.costoproducto,
                state.svalorventa = descripcion.valorventa
               
        },
        agregartable(state) {

            //      this.descripcionmodal = descripcion
            var token = store.state.numero;
            var datos = {
                codigoproducto: state.scodigoproducto,
                costoproducto: state.sconstoproducto,
                disponibleproducto: state.sdisponibleproducto,
                foto: state.sfoto,
                idcaracteristica: state.sidcaracteristica,
                idcategoriaproducto: state.sidcategoriaproducto,
                idcolorproducto: state.sidcolorproducto,
                idgeneroproducto: state.sidgeneroproducto,
                idgrupoproducto: state.sidgrupoproducto,
                idlineaproducto: state.sidlineaproducto,
                idnivelproducto: state.sidnivelproducto,
                idreferencia: state.sreferencia,
               // idproducto: state.sidproducto,
                idtallaproducto: state.sidtallaproducto,
                idtargetproducto: state.sidtargetproducto,
                ivaproducto: state.sivaproducto,
                nombreproducto: state.snombreproducto,
                idusuario:store.state.user,
                idmarca: state.smarca,
                reservaproducto: state.sreservaproducto,
                valorventa: state.svalorventa
              };
             

            this.banderamodal = store.state.banderamodal


            var datosfalso = state.sidproducto;
           
            if (this.banderamodal === true) {


                axios

                    .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/productos", datos, {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + token,
                        },
                    })
                    .then((response) => {
                        let tokenn = response.data.token;
                        //this.respuesta = <z<
                        this.token = tokenn;
                      

                    })

                    .catch((e) => {
                        console.log(e);
                    });
            } else {

                axios

                    .post(
                        "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/productos/UpdateReg/" +
                        datosfalso,
                        datos,
                        {
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer " + token,
                            },
                        }
                    )
                    .then((response) => {
                        let tokenn = response.data.token;
                        //this.respuesta = <z<
                        this.token = tokenn;
                  
                    })

                    .catch((e) => {
                        console.log(e);
                    });
            }

        },


        datosmodal(state, descripcion) {
            state.scodigoproducto = descripcion.codigoproducto,
            state.scostoproducto = descripcion.costoproducto,
            state.sdisponibleproducto = descripcion.disponibleproducto,
            state.smarca= descripcion.idmarca,
            state.sfoto = descripcion.foto,
            state.sidcaracteristica = descripcion.idcaracteristica,
            state.sidcategoriaproducto = descripcion.idcategoriaproducto,
            state.sidcolorproducto = descripcion.idcolorproducto,
            state.sidgeneroproducto = descripcion.idgeneroproducto,
            state.sidgrupoproducto = descripcion.idgrupoproducto,
            state.sidlineaproducto = descripcion.idlineaproducto,
            state.sidnivelproducto = descripcion.idnivelproducto,
            state.sidproducto = descripcion.idproducto,
            state.sidtallaproducto = descripcion.idtallaproducto,
            state.sidtargetproducto = descripcion.idtargetproducto,
            state.sivaproducto = descripcion.ivaproducto,
            state.snombreproducto = descripcion.nombreproducto,
            state.sreferencia = descripcion.idreferencia,
            state.sreservaproducto = descripcion.reservaproducto,
            state.sconstoproducto = descripcion.costoproducto
            state.svalorventa = descripcion.valorventa
            
        

        },



        eliminar(state, api) {
            var token = store.state.numero
            let eliminar = api;
         
            axios
                .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/productos/DeleteReg/" + eliminar,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + token,
                        },
                    })


                .then((response) => {
                    let tokenn = response.data.token;
                    //this.respuesta = <z<
                    state.eliminer = tokenn;
                   
                    //this.bandera = true;
                })

                .catch((e) => {
                    console.log(e);
                });



        },



    },
    actions: {

    },
    getters: {


    },






}